import React from 'react';
import { connect } from 'react-redux';
import HeadBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';

interface ISettingsNavigationProps {
  children: React.ReactNode;
}

const SettingsNavigation: React.FC<ISettingsNavigationProps> = ({ children }) => {
  const baseUrl = `/settings`;
  const myIndustriesUrl = `${baseUrl}/my-industries`;
  const myCompaniesUrl = `${baseUrl}/my-companies`;

  return (
    <>
      <HeadBlock title="Settings">
        <HeadTab title="My Industries" link={myIndustriesUrl} exact={true} />
        <HeadTab title="My Companies" link={myCompaniesUrl} exact={true} />
      </HeadBlock>
      <div>{children}</div>
    </>
  );
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(SettingsNavigation);
